import { createFileRoute } from '@tanstack/react-router';

import { SearchScreen } from '../features/search/SearchScreen';
import { SearchRouteError } from '../features/search/SearchStates';
import { toSearchInput, validateSearchScreenSearch } from '../features/search/search-params';

/**
 * `/search` (§6.6). المسار رقيق بحكم البنية: حالة البحث كلها في search params
 * (§1.2 — «q في search params»: الرابط قابل للمشاركة والرجوع بالتاريخ يحفظ آخر بحث)،
 * وكل التركيب في `features/search`.
 */
export const Route = createFileRoute('/search')({
  validateSearch: validateSearchScreenSearch,
  component: SearchRoute,
  errorComponent: SearchRouteError,
});

function SearchRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SearchScreen
      search={search}
      onSearchChange={(next, replace = false) => {
        // `replace` لكتابة الحقل: التاريخ لا يحمل حرفًا حرفًا، والرجوع يقفز بحثًا كاملًا.
        void navigate({ search: () => toSearchInput(next), replace });
      }}
    />
  );
}
